import PropTypes from 'prop-types';
export const promoBarPropTypes = {
  text: PropTypes.string,
  startData: PropTypes.string,
  endData: PropTypes.string,
  counter: PropTypes.shape({
    visible: PropTypes.bool
  }),
  link: PropTypes.shape({
    label: PropTypes.string,
    href: PropTypes.string
  }),
  variant: PropTypes.string
};